import { StreamItem } from 'widgets/stream-preview/types';

export const getSortingDateField = (item: StreamItem) =>
  item.type === 'Lesson' || item.type === 'Cardstack' || item.type === 'desmos'
    ? item.startDate ?? item.createdDate
    : item.createdDatetime;
